export default "__VITE_ASSET__BHi8MGpV__"